import { queryOptions } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import { getKpiFigures } from "~/modules/user/api/kpiFigure/kpiFigureApiDispatchers.ts";

export const kpiFigureQueries = {
	baseKey: ["kpiFigures"],
	detail: (userId: string) =>
		queryOptions({
			queryKey: [...kpiFigureQueries.baseKey, { userId }],
			queryFn: () => getKpiFigures(userId).then(getDataFromResponse),
			enabled: !!userId,
		}),
};
